import CommercialManager from 'src/local-logic/commercial/commercial-manager';

/**
 * 初始化商业化模块
 */
export function initCommercialManager() {
  const host = getHost();
  const config = {
    request: {
      host,
    },
  };
  CommercialManager.init(config);
}

function getHost(): String {
  let host = 'https://api.nes.smoba.qq.com';
  const debugEnv = window.sessionStorage.getItem('tip_debug_cgi_env');
  if (window.location.origin.indexOf('h5-dev.nes.smoba.qq.com') !== -1
    && debugEnv !== 'prod') {
    // 本地开发 or 测试环境
    host = 'https://api-dev.nes.smoba.qq.com';
  }
  if (window.location.origin.indexOf('h5-test.nes.smoba.qq.com') !== -1
    && debugEnv !== 'prod') {
    // 预发布环境
    host = 'https://api-test.nes.smoba.qq.com';
  }
  return host;
}
